export interface ASINReviewFormData {
  ledgerEntries: string[];
  overallSituation: string[];
  newGPO: string;
  newTargetACoS: string;
  newMaxBid: string;
  newPrice: number | null;
  ppcStatus: string;
  asinReviewCadence: string;
  nameOverride: string;
  startTime: string;
}

export interface ASINReviewFormProps {
  onFormChange?: (data: ASINReviewFormData) => void;
  initialData?: Partial<ASINReviewFormData>;
}

export interface ASINReviewFormState {
  data: ASINReviewFormData;
  isDirty: boolean;
  errors: Partial<Record<keyof ASINReviewFormData, string>>;
}

export const createDefaultFormData = (): ASINReviewFormData => ({
  ledgerEntries: ['', '', '', '', ''],
  overallSituation: ['', '', '', '', ''],
  newGPO: '',
  newTargetACoS: '',
  newMaxBid: '',
  newPrice: null,
  ppcStatus: '',
  asinReviewCadence: '',
  nameOverride: '',
  startTime: new Date().toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  })
});